import { makeStyles } from 'tss-react/mui';

const useStylesCheckboxColumn: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  checkboxColumn: {
    minWidth: 275,
    marginBottom: 20,
  },
}));

export default useStylesCheckboxColumn;
